export default __webpack_public_path__ + "static/media/model_PR_curve.62662b3b.png";